export const initialState = {
    themes: false,
}
